import React from "react";

const Congrats = ({fullName, email}) => {
    return (
        <div className="flex items-center justify-center flex-col mt-6">
            <h1 className="text-[2rem] lg:text-[3rem] font-bold text-center w-full md:w-3/5">Congrats, <span className="text-orange-300">${fullName}!</span> Your Tickt is Ready </h1>
            <p className="lg:text-xl text-center w-full lg:w-1/2">we have emailed your ticket to <span className="text-orange-500">${email}</span> and will send updates in the run up to the event.</p>
        </div>
    )
}

export default Congrats